import { createIcon } from '@chakra-ui/react';

export const ConfigurationIcon = createIcon({
  displayName: 'ConfigurationIcon',
  viewBox: '0 0 120 90',
  defaultProps: {
    fill: 'none',
    height: '6',
    width: '6',
  },
  path: (
    <>
      <path
        d="M59.768 13.625C60.8858 13.6257 61.8162 14.4822 61.9134 15.5959L62.6264 23.8223C64.5929 24.3375 66.4501 25.122 68.163 26.1245L74.4915 20.8181C75.3477 20.0988 76.615 20.1511 77.4056 20.9416L81.3196 24.8554C82.1097 25.6464 82.1626 26.9135 81.4432 27.7698L76.1199 34.0925C77.1193 35.8024 77.8972 37.6557 78.4107 39.6179L86.6539 40.3366C87.7677 40.4338 88.6244 41.3642 88.625 42.482V48.018C88.6244 49.1358 87.7677 50.0662 86.6539 50.1634L78.4055 50.8764C77.8915 52.8343 77.117 54.684 76.1199 56.3906L81.4432 62.73C82.162 63.5862 82.1097 64.8483 81.3196 65.6389L77.4056 69.5529C76.615 70.3436 75.3477 70.4011 74.4915 69.6817L68.1521 64.3532C66.4415 65.3531 64.5894 66.1351 62.6264 66.6498L61.9134 74.9039C61.8162 76.0177 60.8858 76.8744 59.768 76.875H54.232C53.1142 76.8744 52.1838 76.0177 52.0866 74.9039L51.3621 66.6498C49.4014 66.1346 47.551 65.3526 45.8427 64.3532L39.5086 69.6817C38.6523 70.4011 37.3851 70.3488 36.5942 69.5581L32.6804 65.6447C31.89 64.8535 31.8377 63.5862 32.5569 62.73L37.8745 56.3906C36.8777 54.6846 36.1029 52.8337 35.5891 50.8764L27.3459 50.1634C26.2322 50.0662 25.3757 49.1358 25.375 48.018V42.482C25.3757 41.3642 26.2322 40.4338 27.3459 40.3366L35.5835 39.6179C36.097 37.657 36.8708 35.8015 37.8689 34.0925L32.5569 27.7698C31.838 26.9138 31.8906 25.652 32.6804 24.8611L36.5942 20.9473C37.3851 20.1564 38.6522 20.0988 39.5086 20.8181L45.8312 26.1301C47.543 25.1279 49.3979 24.3437 51.3621 23.8279L52.0866 15.5959C52.1838 14.4822 53.1142 13.6257 54.232 13.625H59.768ZM57 35.7715C51.7606 35.7718 47.516 40.0215 47.516 45.2615C47.5171 50.4997 51.7612 54.745 57 54.7455C62.2388 54.7455 66.4887 50.4997 66.4898 45.2615C66.4898 40.0215 62.24 35.7715 57 35.7715Z"
        fill="currentColor"
      />
      <path
        d="M104.438 5H9.5625C7.18079 5 5.25 6.93079 5.25 9.3125V81.1875C5.25 83.5692 7.18079 85.5 9.5625 85.5H104.438C106.819 85.5 108.75 83.5692 108.75 81.1875V9.3125C108.75 6.93079 106.819 5 104.438 5Z"
        stroke="currentColor"
        strokeWidth="8.625"
      />
      <path
        d="M22.5 94.125H91.5"
        stroke="currentColor"
        strokeWidth="8.625"
        strokeLinecap="square"
      />
    </>
  ),
});
